module.exports = __webpack_public_path__ + "img/unilever.a17cb585.svg";